<app-base-list-page
  [headersList]="headerList"
  (rowClick)="projectClicked($event)"
  [logHeaderList]="logHeaderList"
  [multiSelectFilterLists]="multiSelectFilterLists"
  [createNew]="projectClicked"
  [switchDataToggle]="switchDataInList"
  newItemLabel="Nyt projekt"
  #baseListPage>
</app-base-list-page>
